import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import { Tooltip } from "@mui/material";
import { $getRoot } from "lexical";
import { useCallback, useEffect, useState } from "react";
import { useAnalytics } from "../../../../../analytics/analytics";
import { useLexicalContext } from "../../../lexical-context";
import { $isSurveyAnswersNode } from "../../../nodes/survey-answers/helpers";
import { INSERT_SURVEY_ANSWERS_COMMAND } from "../../../types/commands";
import { ToolbarIconButton } from "../toolbar-icon-button";

import type { FC } from "react";

interface Props {
  disabled: boolean;
  onClose?: () => void;
}

export const SurveyAnswersButton: FC<Props> = ({ disabled, onClose }) => {
  const { isSurveyTrigger } = useLexicalContext();
  const [editor] = useLexicalComposerContext();
  const [alreadyInserted, setAlreadyInserted] = useState(false);
  const { gaEvent } = useAnalytics();

  useEffect(() => {
    const check = (editorState: ReturnType<typeof editor.getEditorState>): void => {
      editorState.read(() => {
        setAlreadyInserted($getRoot().getChildren().some($isSurveyAnswersNode));
      });
    };

    check(editor.getEditorState());
    return editor.registerUpdateListener(({ editorState }) => check(editorState));
  }, [editor]);

  const onClick = useCallback(() => {
    editor.dispatchCommand(INSERT_SURVEY_ANSWERS_COMMAND, undefined);
    gaEvent("survey_response_block_added", { action: "manual" });
    onClose?.();
  }, [editor, gaEvent, onClose]);

  if (!isSurveyTrigger) return null;

  return (
    <Tooltip title={alreadyInserted ? "This Communication already contains survey results" : ""}>
      <span>
        <ToolbarIconButton
          data-analytics-id="lexical-toolbar-add-survey-answers"
          sx={{ width: "100%", justifyContent: "start" }}
          aria-label="Insert survey answers"
          disabled={disabled || alreadyInserted}
          onClick={onClick}
          label="Survey results"
          icon={<FactCheckOutlinedIcon />}
        />
      </span>
    </Tooltip>
  );
};
